<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="filter-forms-nav pages-title-nav p-0">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="sample-details-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
            <ul class="page-name-div sample-name-list d-flex align-items-center">
              <a class="left-arrow" routerLink="/dashboard/samples">
                <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
                </a> <app-tab-main [links]="tabs"></app-tab-main>
                <span class="ml-auto d-flex">
                  <span class="my-auto" *objectHasPermission="permissionObject; action: editAction">
                    <button class="edit-sample-btn"
                      [disabled]="isNonEditableStatus"
                      [title]="isNonEditableStatus ? ('Sample with this status cannot be edited' | translate) : ('Edit Sample' | translate)"
                      (click)="openSampleDialog()">
                      <span class="material-symbols-outlined">edit</span>
                      {{ 'Edit' | translate }}
                    </button>
                  </span>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="page-content-inner-wrap card-style-sec sample-details-page-wrap custom-scrollbar">
        <div class="container-fluid">

          <!-- ═══════════════════════════════════════════════════════════ -->
          <!-- HERO HEADER — Sample identity prominent banner             -->
          <!-- ═══════════════════════════════════════════════════════════ -->
          @if (sampleDetails) {
            <div class="hero-header" [class.hero-header--outlier]="sampleDetails?.isOutlier">
              <div class="hero-header-main">
                <div class="hero-identity">
                  @if (sampleDetails?.sampleNumber) {
                    <span class="hero-identity-field">
                      <span class="hero-identity-label">{{ (columnDetails?.sampleNumber?.displayName || 'Sample #') | translate }}</span>
                      <span class="hero-sample-number" [class.hero-sample-number--outlier]="sampleDetails?.isOutlier">{{ sampleDetails.sampleNumber }}</span>
                    </span>
                  }
                  @if (sampleDetails?.isOutlier) {
                    <span class="hero-outlier-badge">
                      <span class="material-symbols-outlined">flag</span>
                      {{ 'Outlier' | translate }}
                    </span>
                  }
                  @if (sampleDetails?.sampleNumber && sampleTypeName) {
                    <span class="hero-separator">·</span>
                  }
                  @if (sampleTypeName) {
                    <span class="hero-identity-field">
                      <span class="hero-identity-label">{{ (columnDetails?.sampleType?.displayName || 'Sample Type') | translate }}</span>
                      <span class="hero-meta">{{ sampleTypeName }}</span>
                    </span>
                  }
                  @if (sampleTypeName && sampleCategoryName) {
                    <span class="hero-separator">·</span>
                  }
                  @if (sampleCategoryName) {
                    <span class="hero-identity-field">
                      <span class="hero-identity-label">{{ (columnDetails?.sampleCategory?.displayName || 'Sample Category') | translate }}</span>
                      <span class="hero-meta">{{ sampleCategoryName }}</span>
                    </span>
                  }
                  @if (sampleDetails?.surveyName) {
                    <span class="hero-separator">·</span>
                  }
                  @if (sampleDetails?.surveyName) {
                    <span class="hero-identity-field">
                      <span class="hero-identity-label">{{ (columnDetails?.sampleSurveyId?.displayName || 'Sample Survey') | translate }}</span>
                      @if (sampleDetails?.sampleSurveyId) {
                        <a class="hero-meta field-link" [routerLink]="'/dashboard/survey-details/' + sampleDetails.sampleSurveyId">{{ sampleDetails.surveyName }}</a>
                      } @else {
                        <span class="hero-meta">{{ sampleDetails.surveyName }}</span>
                      }
                    </span>
                  }
                  @if (sampleDetails?.alternateSampleNumber) {
                    <span class="hero-separator">·</span>
                  }
                  @if (sampleDetails?.alternateSampleNumber) {
                    <span class="hero-identity-field">
                      <span class="hero-identity-label">{{ (columnDetails?.alternateSampleNumber?.displayName || 'Alt Sample #') | translate }}</span>
                      <span class="hero-meta">{{ sampleDetails.alternateSampleNumber }}</span>
                    </span>
                  }
                </div>
                <div class="hero-details">
                  @if (sampleDetails?.segName) {
                    <span class="hero-seg">
                      <span class="hero-seg-label">{{ (columnDetails?.segId?.displayName || 'SEG') | translate }}:</span>
                      <span class="hero-seg-value">{{ sampleDetails.segName }}</span>
                    </span>
                  }
                  @if (sampleDetails?.organizationLevelId) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ (columnDetails?.organizationLevelId?.displayName || 'Organization Level') | translate }}:</span>
                      <span class="hero-detail-value">{{ sampleDetails.organizationLevelName }}</span>
                    </span>
                  }
                  @if (heroSampleDate) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ (columnDetails?.startDate?.displayName || 'Date and Time of Sampling') | translate }}:</span>
                      <span class="hero-detail-value">{{ heroSampleDate }}</span>
                    </span>
                  }
                  @if (heroRunTime) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ (columnDetails?.runTime?.displayName || 'Run Time (sec)') | translate }}:</span>
                      <span class="hero-detail-value">{{ heroRunTime }}</span>
                    </span>
                  }
                  @if (sampleDetails?.isOutlier && sampleDetails?.outlierReason) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ 'Outlier Reason' | translate }}:</span>
                      <span class="hero-detail-value outlier-reason-text">{{ sampleDetails.outlierReason }}</span>
                    </span>
                  }
                  @if (isApprovedStatus && approvedByName) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ 'Approved by' | translate }}:</span>
                      <span class="hero-detail-value">{{ approvedByName }}</span>
                    </span>
                  }
                  @if (isApprovedStatus && approvedOnDisplay) {
                    <span class="hero-detail-item">
                      <span class="hero-detail-label">{{ 'Approved on' | translate }}:</span>
                      <span class="hero-detail-value">{{ approvedOnDisplay }}</span>
                    </span>
                  }
                </div>
              </div>
              <div class="hero-actions">
                <!-- Generate Report button — only shown when status allows it AND user can read PII -->
                <ng-container *objectHasPermission="piiPermissionObject; action: readAction">
                  @if (canGenerateReport) {
                    <button class="generate-report-btn"
                      [disabled]="isLoading || isGeneratingReport"
                      (click)="openReportGenerationPopup()">
                      @if (!isGeneratingReport) {
                        <i class="fas fa-file-pdf"></i>
                      }
                      @if (isGeneratingReport) {
                        <i class="fas fa-spinner fa-spin"></i>
                      }
                      <span>{{ isGeneratingReport ? ('Generating' | translate) + '...' : ('Generate Letter' | translate) }}</span>
                    </button>
                  }
                </ng-container>
                <!-- Report chips — show one inline when there are many -->
                @for (report of visibleReports | slice:0:maxInlineReports; track trackById($index, report)) {
                  <a class="hero-report-chip" (click)="openReport(report)"
                    title="{{ report.name || report.fileName }}">
                    <i class="fas fa-file-pdf"></i>
                    <span class="hero-report-name">{{ report.name || report.fileName }}</span>
                    @if (report.fileAttachments?.[0]; as firstAttachment) {
                      @if (firstAttachment.emailStatus != null) {
                        <span class="hero-report-email"
                          [class.status-sent]="firstAttachment.emailStatus === emailStatusEnum.Sent"
                          [class.status-pending]="firstAttachment.emailStatus === emailStatusEnum.Pending"
                          [class.status-failed]="firstAttachment.emailStatus === emailStatusEnum.Failed">
                          <i class="fa fa-envelope"></i>
                          {{ emailStatusEnum[firstAttachment.emailStatus] | translate }}
                          @if (firstAttachment.emailSentDate && firstAttachment.emailStatus === emailStatusEnum.Sent) {
                            <span>
                              · {{ firstAttachment.emailSentDate | dateFormat }}
                            </span>
                          }
                        </span>
                      }
                    }
                    <i class="fas fa-external-link-alt hero-report-open"></i>
                  </a>
                }
                @if (visibleReports.length > maxInlineReports) {
                  <button class="hero-report-dropdown-btn"
                    [matMenuTriggerFor]="allReportsMenu">
                    <i class="fas fa-file-alt"></i>
                    <span>+{{ visibleReports.length - maxInlineReports }} {{ 'more' | translate }}</span>
                    <i class="fas fa-chevron-down"></i>
                  </button>
                }
                <mat-menu #allReportsMenu="matMenu" class="hero-report-menu">
                  @for (report of visibleReports | slice:maxInlineReports; track trackById($index, report)) {
                    <button mat-menu-item
                      (click)="openReport(report)">
                      <i class="fas fa-file-pdf red-text mr-2"></i>
                      <span>{{ report.name || report.fileName }}</span>
                    </button>
                  }
                </mat-menu>
                <mat-form-field appearance="fill" class="status-select">
                  <mat-select [(value)]="sampleStatus" panelClass="status-dropdown-panel"
                    (selectionChange)="onStatusChange()">
                    <mat-select-trigger>
                      <span class="status-badge" [ngClass]="getStatusBadgeClass(sampleStatus)">
                        {{ sampleStatusName | translate }}
                      </span>
                    </mat-select-trigger>
                    @for (status of sampleStatusList; track trackById($index, status)) {
                      <mat-option class="status-dropdown-options"
                        [value]="status.id">
                        <span class="status-badge" [ngClass]="getStatusBadgeClass(status.id)">
                          {{status.name | translate}}
                        </span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- Mark/Remove Outlier Action Button -->
                <ng-container *objectHasPermission="permissionObject; action: editAction">
                  <button class="mark-outlier-btn"
                    [class.mark-outlier-btn--active]="sampleDetails?.isOutlier"
                    [title]="sampleDetails?.isOutlier ? ('Remove Outlier' | translate) : ('Mark as Outlier' | translate)"
                    (click)="sampleDetails?.isOutlier ? unmarkAsOutlier() : markAsOutlierDialog()">
                    <span class="material-symbols-outlined">flag</span>
                    {{ (sampleDetails?.isOutlier ? 'Remove Outlier' : 'Mark as Outlier') | translate }}
                  </button>
                </ng-container>
                <!-- Un-approve Action Button — only for users with Sample UpdateHierarchy -->
                @if (canUnapprove) {
                  <button class="unapprove-btn"
                    [title]="'Un-approve' | translate"
                    (click)="unApproveSample()">
                    <span class="material-symbols-outlined">lock_open</span>
                    {{ 'Un-approve' | translate }}
                  </button>
                }
              </div>
            </div>
          }

          <!-- Full-width layout (no 8/4 split) -->
          <div class="full-width-content">

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- RESULTS & COMPLIANCE — Gravimetric result cards         -->
            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- Full results view when gravimetric data exists -->
            @if (hasGravimetricResults) {
              <div class="results-section">
                <h3 class="section-title">
                  <img src="assets/images/agents.svg" class="mr-1">
                  {{ 'Results & Compliance' | translate }}
                  <ng-container *objectHasPermission="permissionObject; action: editAction">
                    @if (!isNonEditableStatus) {
                      <button class="results-edit-btn"
                        (click)="openLabResultsDialog()">
                        <span class="material-symbols-outlined">edit</span>
                        {{ 'Edit Results' | translate }}
                      </button>
                    }
                  </ng-container>
                </h3>
                <div class="section">
                  <app-gravimetric-results class="w-100"
                    [iHLabResults]="$safeNavigationMigration(sampleDetails?.ihLabResults)"
                    [isSampleTypeNoise]="sampleDetails?.sampleType === sampleTypeEnum.Noise"
                    [isSampleTypeBiological]="sampleDetails?.sampleType === sampleTypeEnum.Biological">
                  </app-gravimetric-results>
                </div>
              </div>
            }
            <!-- Compact bar when no gravimetric results -->
            @if (sampleDetails && !hasGravimetricResults) {
              <div class="results-empty-bar">
                <img src="assets/images/agents.svg" class="results-empty-icon">
                <span class="results-empty-text">{{ 'No results available' | translate }}</span>
                <ng-container *objectHasPermission="permissionObject; action: editAction">
                  @if (!isNonEditableStatus) {
                    <button class="results-add-btn" (click)="openLabResultsDialog()">
                      <span class="material-symbols-outlined">add</span>
                      {{ 'Add Results' | translate }}
                    </button>
                  }
                </ng-container>
              </div>
            }

            <!-- Correction Settings — user-selected, shown separately below results -->
            @if (hasGravimetricResults) {
              <div class="correction-settings">
                <div class="correction-pills">
                  @if (sampleDetails.unsampledTimeCorrectionName && sampleDetails?.sampleType !== sampleTypeEnum.Biological) {
                    <span class="correction-pill">
                      <span class="correction-label">{{ columnDetails?.unsampledTimeCorrection?.displayName || ('Unsampled Time Correction' | translate) }}</span>
                      <span class="correction-value">{{ sampleDetails.unsampledTimeCorrectionName }}</span>
                    </span>
                  }
                  @if (hasSampleMediaName) {
                    <span class="correction-pill">
                      <span class="correction-label">{{ 'Media' | translate }}</span>
                      <span class="correction-value">{{ sampleDetails.sampleMediaName }}</span>
                    </span>
                  }
                  @if (sampleDetails?.sampleType !== sampleTypeEnum.Biological) {
                    <span class="correction-pill">
                      <span class="correction-label">{{ 'Shift Correction' | translate }}</span>
                      <span class="correction-value">{{ (sampleDetails.applyShiftCorrection ? 'Yes' : 'No') | translate }}</span>
                    </span>
                  }
                  @if (sampleDetails?.sampleType !== sampleTypeEnum.Biological) {
                    <span class="correction-pill">
                      <span class="correction-label">{{ 'Pressure Correction' | translate }}</span>
                      <span class="correction-value">{{ (sampleDetails.applyPressureCorrection ? 'Yes' : 'No') | translate }}</span>
                    </span>
                  }
                </div>
              </div>
            }

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- JURISDICTIONS & AGENTS TABLE                            -->
            <!-- ═══════════════════════════════════════════════════════ -->
            @if (sampleDetails?.ihLabResults?.length) {
              <div class="jurisdictions-section">
                <h3 class="section-title">
                  <img src="assets/images/agents.svg" class="mr-1">
                  {{ 'Jurisdictions and Agents' | translate }}
                </h3>
                <div class="section">
                  <div class="custom-theme-table pt-0">
                    <div class="table-responsive outer-bordered-table custom-scrollbar curved-section-shadow">
                      <table mat-table [dataSource]="$safeNavigationMigration(sampleDetails?.ihLabResults)"
                        class="table table-striped custom-scrollbar">
                        <ng-container matColumnDef="agentName">
                          <th mat-header-cell *matHeaderCellDef class="left-aligned">{{ 'Agent' | translate }}</th>
                          <td mat-cell *matCellDef="let element" class="left-aligned">{{ element.agentName }}</td>
                        </ng-container>
                        <ng-container matColumnDef="agentGroupName">
                          <th mat-header-cell *matHeaderCellDef class="left-aligned">{{ 'Agent Group' | translate }}</th>
                          <td mat-cell *matCellDef="let element" class="left-aligned">{{ element.agentGroupName || '-' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="jurisdictionName">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Jurisdiction' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.jurisdictionName }}</td>
                        </ng-container>
                        <ng-container matColumnDef="oelTypeId">
                          <th mat-header-cell *matHeaderCellDef>{{ 'OEL Type' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.oelTypeName }}</td>
                        </ng-container>
                        <ng-container matColumnDef="oel">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Base OEL' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.oelValue }}</td>
                        </ng-container>
                        <ng-container matColumnDef="correctedOEL">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Corrected OEL' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.correctedOELValue }}</td>
                        </ng-container>
                        <ng-container matColumnDef="applyShiftCorrection">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Shift Correction' | translate }}</th>
                          <td mat-cell *matCellDef="let element">
                            <span class="material-symbols-outlined correction-icon"
                              [class.applied]="element.applyShiftCorrection"
                              [class.not-applied]="!element.applyShiftCorrection"
                              [title]="(element.applyShiftCorrection ? 'Applied' : 'Not Applied') | translate">
                              {{ element.applyShiftCorrection ? 'check_circle' : 'remove' }}
                            </span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="applyPressureCorrection">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Pressure Correction' | translate }}</th>
                          <td mat-cell *matCellDef="let element">
                            <span class="material-symbols-outlined correction-icon"
                              [class.applied]="element.applyPressureCorrection"
                              [class.not-applied]="!element.applyPressureCorrection"
                              [title]="(element.applyPressureCorrection ? 'Applied' : 'Not Applied') | translate">
                              {{ element.applyPressureCorrection ? 'check_circle' : 'remove' }}
                            </span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="analyticalMethodId">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Analytical Method' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.analyticalMethodName || '-' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="oelCorrectionMethod">
                          <th mat-header-cell *matHeaderCellDef>{{ 'Correction Method' | translate }}</th>
                          <td mat-cell *matCellDef="let element">{{ element.oelCorrectionMethodName }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                        [class.even-row]="even"></tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- SAMPLING DETAILS + EQUIPMENT — Side-by-side 50/50      -->
            <!-- ═══════════════════════════════════════════════════════ -->
            @if (overviewFields?.length || metricFields?.length || equipmentFields?.length || calibrationFields?.length) {
              <div class="two-col-row">
                <div class="two-col-left">
                  <!-- Sampling Details (merged overview + metrics) -->
                  <h3 class="section-title">
                    <img src="assets/images/sample-overview.svg" class="mr-1">
                    {{ 'Sampling Details' | translate }}
                  </h3>
                  <div class="section">
                    <div class="field-container">
                      @for (field of overviewFields; track trackByIndex($index)) {
                        @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                          <div class="field">
                            <div class="field-label">{{ field.label | translate }}</div>
                            <div class="field-value">{{ field.value }}
                              @if (field?.isFlag) {
                                <span class="flag"><img src="assets/images/flag.svg">{{ 'Flagged' | translate }}</span>
                              }
                              @if (field?.note) {
                                <span class="note">{{ field.note }}</span>
                              }
                            </div>
                          </div>
                        }
                      }
                      @for (field of metricFields; track trackByIndex($index)) {
                        @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                          <div class="field">
                            <div class="field-label">{{ field.label | translate }}</div>
                            <div class="field-value">{{ field.value }}
                              @if (field?.isFlag) {
                                <span class="flag"><img src="assets/images/flag.svg">{{ 'Flagged' | translate }}</span>
                              }
                              @if (field?.note) {
                                <span class="note">{{ field.note }}</span>
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="two-col-right">
                  <!-- Equipment & Calibration -->
                  <h3 class="section-title">
                    <img src="assets/images/equipment.svg" class="mr-1">
                    {{ 'Equipment & Calibration' | translate }}
                    @if (hasVisibleCalibrationFields) {
                      <button class="ml-auto blue-text d-flex align-items-center cursor-pointer unstyled-btn"
                        (click)="viewCertificate()">
                        <img src="assets/images/certificate.svg" class="mr-1" alt="">
                        {{ 'View Certificate' | translate }}
                      </button>
                    }
                  </h3>
                  <div class="section">
                    <div class="field-container">
                      @for (field of equipmentFields; track trackByIndex($index)) {
                        @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                          <div class="field">
                            <div class="field-label">{{ field.label | translate }}</div>
                            <div class="field-value">{{ field.value }}</div>
                          </div>
                        }
                      }
                      @for (field of calibrationFields; track trackByIndex($index)) {
                        @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                          <div class="field">
                            <div class="field-label">{{ field.label | translate }}</div>
                            <div class="field-value">
                              @if (field.link) {
                                <a class="field-link" [routerLink]="field.link">{{ field.value }}</a>
                              } @else {
                                {{ field.value }}
                              }
                              @if (field?.isFlag) {
                                <span class="flag"><img src="assets/images/flag.svg">{{ 'Flagged' | translate }}</span>
                              }
                            </div>
                          </div>
                        }
                      }
                      @if (!hasVisibleEquipmentFields && !hasVisibleCalibrationFields) {
                        <div class="empty-state">
                          <span class="empty-state-text">{{ 'No equipment or calibration data' | translate }}</span>
                        </div>
                      }
                    </div>
                  </div>
                  <!-- Lab Chain of Custody -->
                  <div class="lab-coc-section">
                    <h3 class="section-title">
                      <img src="assets/images/link.svg" class="mr-1">
                      {{ 'Lab Chain of Custody' | translate }}
                      @if (hasVisibleLabFields) {
                        <button class="ml-auto blue-text d-flex align-items-center cursor-pointer unstyled-btn"
                          (click)="viewCOC()">
                          <img src="assets/images/certificate.svg" class="mr-1" alt="">
                          {{ 'View COC' | translate }}
                        </button>
                      }
                    </h3>
                    <div class="section" style="position: relative;">
                      @if (sampleDetails?.labRequisitionId && !isNonEditableStatus) {
                        <button class="unlink-coc-btn"
                          (click)="unlinkCOC()" [title]="'Unlink from Chain of Custody' | translate">
                          <span class="material-symbols-outlined">link_off</span>
                          {{ 'Unlink' | translate }}
                        </button>
                      }
                      <div class="field-container">
                        @for (field of labFields; track trackByIndex($index)) {
                          @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                            <div class="field">
                              <div class="field-label">{{ field.label | translate }}</div>
                              <div class="field-value">{{ field.value }}</div>
                            </div>
                          }
                        }
                        @if (!hasVisibleLabFields) {
                          <div class="empty-state">
                            <span class="empty-state-text">{{ 'No lab chain of custody data' | translate }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- CONTEXT — Employee + Location + Weather + Controls     -->
            <!-- Collapsible, 4 mini-sections in a row                  -->
            <!-- ═══════════════════════════════════════════════════════ -->
            @if (employeeFields?.length || locationFields?.length || controlFields?.length || healthFields?.length || sampleDetails?.sampleTasks?.length || sampleDetails?.sampleType !== sampleTypeEnum.Wipe) {
              <div class="context-section">
                <h3 class="section-title context-toggle" (click)="contextCollapsed = !contextCollapsed">
                  <img src="assets/images/employee.svg" class="mr-1">
                  {{ 'Field Conditions' | translate }}
                  <span class="material-symbols-outlined toggle-icon" [class.collapsed]="contextCollapsed">
                    expand_more
                  </span>
                </h3>
                <div class="context-grid" [class.collapsed]="contextCollapsed">
                  <!-- Employee & PPE (half-wide, split: employee left / PPE right) -->
                  @if (employeeFields?.length) {
                    <div class="context-card half-wide">
                      <div class="context-card-title-row">
                        <div class="context-card-title">{{ 'Employee & PPE' | translate }}</div>
                        @if (hasPiiFields) {
                          @if (!piiMasked) {
                            <button type="button" class="toggle-visibility pii-reveal-toggle" (click)="toggleReveal()">
                              <img [src]="piiRevealed ? 'assets/images/EyeHide.svg' : 'assets/images/EyeReveal.svg'" alt="{{ 'Toggle visibility' | translate }}">
                              <span>{{ (piiRevealed ? 'Hide' : 'Reveal') | translate }}</span>
                            </button>
                          }
                          @if (piiMasked) {
                            <span class="status-badge status-badge--inactive pii-lock-chip">
                              <span class="material-symbols-outlined">lock</span>
                              {{ 'Identity restricted' | translate }}
                            </span>
                          }
                        }
                      </div>
                      <div class="employee-ppe-split">
                        <div class="employee-fields-col">
                          <div class="context-card-fields">
                            @for (field of employeeFields; track trackByIndex($index)) {
                              @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                                <div class="context-field">
                                  <span class="field-label">{{ field.label | translate }}</span>
                                  <span class="field-value">{{ (field.isPii && !piiRevealed) ? '****' : field.value }}</span>
                                </div>
                              }
                            }
                          </div>
                        </div>
                        <div class="ppe-col">
                          <div class="ppe-col-title">{{ 'Personal Protective Equipment' | translate }}</div>
                          @if (ppeAssignments.length) {
                            <div class="ppe-pills">
                              @for (ppe of ppeAssignments; track trackByIndex($index)) {
                                <span class="ppe-pill">{{ ppe.ppeName }}</span>
                              }
                            </div>
                          } @else {
                            <span class="field-value empty-value">{{ 'None assigned' | translate }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Process & Tasks (half-wide, same row as Employee when present) -->
                  @if (controlFields?.length || sampleDetails?.sampleTasks?.length) {
                    <div class="context-card half-wide">
                      <div class="context-card-title">{{ 'Process & Tasks' | translate }}</div>
                      <div class="context-card-fields">
                        <!-- Process -->
                        <div class="context-field">
                          <span class="field-label">{{ 'Process' | translate }}</span>
                          <span class="field-value" [class.empty-value]="!hasProcessName">
                            {{ hasProcessName ? sampleDetails.processName : ('None' | translate) }}
                          </span>
                        </div>
                        <!-- Other control fields -->
                        @for (field of controlFields; track trackByIndex($index)) {
                          @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                            <div class="context-field">
                              <span class="field-label">{{ field.label | translate }}</span>
                              <span class="field-value">{{ field.value }}</span>
                            </div>
                          }
                        }
                        <!-- Sample Tasks -->
                        @if (sampleDetails?.sampleTasks?.length) {
                          <div class="context-field task-field">
                            <span class="field-label">{{ 'Tasks' | translate }}</span>
                            <div class="task-table-container">
                              <div class="custom-theme-table pt-0">
                                <div class="table-responsive outer-bordered-table custom-scrollbar curved-section-shadow">
                                  <table mat-table [dataSource]="$safeNavigationMigration(sampleDetails?.sampleTasks)" class="table table-striped custom-scrollbar">
                                    <ng-container matColumnDef="taskGroupName">
                                      <th mat-header-cell *matHeaderCellDef class="left-aligned">{{ 'Task Group' | translate }}</th>
                                      <td mat-cell *matCellDef="let task" class="left-aligned">{{ task.taskGroupName || '-' }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="taskName">
                                      <th mat-header-cell *matHeaderCellDef class="left-aligned">{{ 'Task Name' | translate }}</th>
                                      <td mat-cell *matCellDef="let task" class="left-aligned">{{ task.taskName }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="approximateTimeMinutes">
                                      <th mat-header-cell *matHeaderCellDef>{{ 'Approx. Time (Mins)' | translate }}</th>
                                      <td mat-cell *matCellDef="let task">{{ task.approximateTimeMinutes }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="applicablePpeWorn">
                                      <th mat-header-cell *matHeaderCellDef>{{ 'PPE Worn' | translate }}</th>
                                      <td mat-cell *matCellDef="let task">
                                        <span class="material-symbols-outlined correction-icon"
                                          [class.applied]="task.applicablePpeWorn"
                                          [class.not-applied]="!task.applicablePpeWorn"
                                          [title]="(task.applicablePpeWorn ? 'Yes' : 'No') | translate">
                                          {{ task.applicablePpeWorn ? 'check_circle' : 'remove' }}
                                        </span>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="taskTableColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: taskTableColumns;"></tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- Row 2: Location | Weather -->
                  <!-- Location — hidden entirely for categories where location does not apply (e.g. Air Personal, DASH-2980) -->
                  @if (hasApplicableLocationFields) {
                    <div class="context-card">
                      <div class="context-card-title-row">
                        <div class="context-card-title">{{ 'Location' | translate }}</div>
                        @if (locationIsPii && piiMasked) {
                          <span class="status-badge status-badge--inactive pii-lock-chip">
                            <span class="material-symbols-outlined">lock</span>
                            {{ 'Identity restricted' | translate }}
                          </span>
                        }
                      </div>
                      <div class="context-card-fields">
                        @for (field of locationFields; track trackByIndex($index)) {
                          @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                            <div class="context-field">
                              <span class="field-label">{{ field.label | translate }}</span>
                              <span class="field-value">{{ (field.isPii && !piiRevealed) ? '****' : field.value }}</span>
                            </div>
                          }
                        }
                        @if (!hasVisibleLocationFields) {
                          <div class="context-empty">
                            <span class="empty-value">{{ 'No location information' | translate }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- Weather -->
                  @if (sampleDetails?.sampleType !== sampleTypeEnum.Wipe) {
                    <div class="context-card">
                      <div class="context-card-title">{{ columnDetails?.weatherCondition?.displayName || ('Weather' | translate) }}</div>
                      <div class="context-card-fields weather-inline">
                        @if (hasTemperatureMinC) {
                          <div class="context-field">
                            <span class="field-label">{{ 'Min' | translate }}</span>
                            <span class="field-value">{{ sampleDetails.temperatureMinC }}{{ temperatureUnit }}</span>
                          </div>
                        }
                        @if (hasTemperatureMaxC) {
                          <div class="context-field">
                            <span class="field-label">{{ 'Max' | translate }}</span>
                            <span class="field-value">{{ sampleDetails.temperatureMaxC }}{{ temperatureUnit }}</span>
                          </div>
                        }
                        @if (hasHumidityPercent) {
                          <div class="context-field">
                            <span class="field-label">{{ 'Humidity' | translate }}</span>
                            <span class="field-value">{{ sampleDetails.humidityPercent }}%</span>
                          </div>
                        }
                        @if (hasPressureMmhg) {
                          <div class="context-field">
                            <span class="field-label">{{ 'Pressure' | translate }}</span>
                            <span class="field-value">{{ sampleDetails.pressureMmhg }} mmHg</span>
                          </div>
                        }
                        @if (sampleDetails?.weatherCondition != null) {
                          <div class="context-field">
                            <span class="field-label">{{ 'Condition' | translate }}</span>
                            <span class="field-value">{{ weatherConditionEnum[sampleDetails.weatherCondition] }}</span>
                          </div>
                        }
                        @if (!hasTemperatureMinC && !hasTemperatureMaxC && !hasHumidityPercent && !hasPressureMmhg && sampleDetails?.weatherCondition == null) {
                          <div class="context-empty">
                            <span class="empty-value">{{ 'No weather data recorded' | translate }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- Health & Exposure -->
                  @if (healthFields?.length) {
                    <div class="context-card">
                      <div class="context-card-title">{{ 'Health & Exposure' | translate }}</div>
                      <div class="context-card-fields">
                        @for (field of healthFields; track trackByIndex($index)) {
                          @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
                            <div class="context-field">
                              <span class="field-label">{{ field.label | translate }}</span>
                              <span class="field-value">{{ field.value }}</span>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                  <!-- Documents & Notes -->
                  <div class="context-card">
                    <div class="context-card-title">{{ 'Documents & Notes' | translate }}</div>
                    <div class="context-card-fields">
                      <!-- Sample Attachments -->
                      @if (sampleDetails?.fileAttachments?.length) {
                        <div>
                          <div class="documents-subsection-title">{{ 'Attachments' | translate }}</div>
                          @for (attachment of sampleDetails?.fileAttachments; track trackById($index, attachment)) {
                            <div>
                              <div class="attachment-item compact">
                                <span class="file-name"><img [src]="attachment.imgSrc" class="mr-1">
                                {{ attachment.name }}</span>
                                <button mat-icon-button color="primary" class="download-btn-sm"
                                  [attr.aria-label]="'Download ' + attachment.name"
                                  (click)="downloadAttachment(attachment)">
                                  <img src="assets/images/download.svg" alt="">
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      <!-- Notes -->
                      @if (hasVoidReason) {
                        <div class="context-field">
                          <span class="field-label">{{ 'Void Reason' | translate }}</span>
                          <span class="field-value">{{ sampleDetails.voidReason }}</span>
                        </div>
                      }
                      @if (hasSummaryNote) {
                        <div class="context-field">
                          <span class="field-label">{{ 'Additional Notes' | translate }}</span>
                          <span class="field-value">{{ sampleDetails.summaryNote }}</span>
                        </div>
                      }
                      <!-- Empty state -->
                      @if (!sampleDetails?.fileAttachments?.length && !hasSummaryNote && !hasVoidReason) {
                        <div class="context-empty">
                          <span class="empty-value">{{ 'No documents or notes' | translate }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }

          </div>
        </div>
      </div>
    </app-sidebar-layout>
  </div>

  <!-- Kept for backward compat — #displaySection template used nowhere now -->
  <ng-template #displaySection let-imageSrc="imageSrc" let-title="title" let-fields="fields">
    <h3 class="section-title">
      <img [src]="imageSrc" class="mr-1">
      {{ title | translate}}
    </h3>
    <div class="section">
      <div class="field-container">
        @for (field of fields; track trackByIndex($index)) {
          @if ((field?.isShown == undefined || field?.isShown) && hasValue(field.value)) {
            <div class="field">
              <div class="field-label">{{ field.label | translate}}</div>
              <div class="field-value">{{ field.value }}
                @if (field?.isFlag) {
                  <span class="flag"><img src="assets/images/flag.svg">{{ 'Flagged' |
                  translate }}</span>
                }
                @if (field?.note) {
                  <span class="note">{{field.note}}</span>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  @if (showReportGenerationPopup) {
    <app-report-generation-popup [entity]="sampleDetails" [entityType]="'EmployeeLetter'"
      [entityId]="$safeNavigationMigration(sampleDetails?.id)" [isVisible]="showReportGenerationPopup" [organizationLevels]="organizationsList"
      [columnDetails]="columnDetails"
    (close)="closeReportGenerationPopup()" (pdfGenerated)="onPdfGenerated($event)"></app-report-generation-popup>
  }

  <app-flyout-container #flyout></app-flyout-container>
